export default "__VITE_ASSET__CNztpfnx__"